import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SimpleBotIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "SimpleBot",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M7.59 19.92s3.05.33 7.75.36v1.66c-1.34 0-2.66.11-3.94.31l.15-.02c-.86.06-1.55.69-1.7 1.52-.22.89-.35 1.9-.35 2.94v.06c0 .64.05 1.27.13 1.89v-.07c1.87.89 4.07 1.42 6.39 1.42 2.15 0 4.19-.45 6.05-1.26l-.1.04c.1-.61.16-1.31.16-2.02 0-1.03-.12-2.03-.34-3l.02.09c-.13-.85-.81-1.51-1.66-1.6-1.04-.17-2.24-.28-3.47-.3h-.02v-1.67c4.75 0 7.73-.36 7.74-.36 2.01-.17 2.7-1.06 2.92-1.8.41-1.07.65-2.31.66-3.61-.01-1.3-.25-2.55-.68-3.69l.02.07c-.22-.73-.9-1.62-2.91-1.79 0 0-3.02-.33-7.75-.36V6.98c1.1-.29 1.9-1.28 1.9-2.45 0-1.4-1.13-2.54-2.54-2.54s-2.54 1.13-2.54 2.54c0 1.17.8 2.16 1.88 2.45h.02v1.75c-4.75 0-7.73.36-7.74.36-2.04.17-2.72 1.09-2.91 1.77-.41 1.08-.65 2.33-.66 3.64 0 1.3.25 2.53.67 3.67l-.02-.07c.18.74.83 1.65 2.89 1.82Zm13.86-7.1a2.9 2.9 0 0 1 2.8 2.73v.03c0 .34-.28.62-.62.63-.34 0-.62-.28-.63-.62-.07-.81-.72-1.45-1.53-1.5-.82.05-1.47.69-1.54 1.49 0 .35-.28.62-.63.62h-.02a.64.64 0 0 1-.62-.64v-.02c.07-1.5 1.28-2.69 2.78-2.72Zm-10.96 0a2.9 2.9 0 0 1 2.8 2.73v.03c0 .34-.28.62-.62.63-.34 0-.62-.28-.63-.62-.07-.81-.72-1.45-1.53-1.5-.83.04-1.49.68-1.57 1.49s0 .06 0 .08c0 .35-.28.64-.64.64s-.64-.28-.64-.64v-.08c.08-1.51 1.3-2.71 2.81-2.76Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M12.14 20.14c-.63 0-1.14-.51-1.14-1.14a1.14 1.14 0 1 0-2.28 0 1.14 1.14 0 1 1-2.28 0c0-1.89 1.54-3.43 3.43-3.43S13.3 17.11 13.3 19c0 .63-.51 1.14-1.14 1.14ZM23.57 20.14c-.63 0-1.14-.51-1.14-1.14a1.14 1.14 0 1 0-2.28 0 1.14 1.14 0 1 1-2.28 0c0-1.89 1.54-3.43 3.43-3.43s3.43 1.54 3.43 3.43c0 .63-.51 1.14-1.14 1.14Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M25.86 29.29H5.29c-1.89 0-3.43-1.54-3.43-3.43V14.43C1.86 12.54 3.4 11 5.29 11h20.57c1.89 0 3.43 1.54 3.43 3.43v11.43c0 1.89-1.54 3.43-3.43 3.43m-20.57-16c-.63 0-1.14.51-1.14 1.14v11.43c0 .63.51 1.14 1.14 1.14h20.57c.63 0 1.14-.51 1.14-1.14V14.43c0-.63-.51-1.14-1.14-1.14zM15.57 8.71c-1.89 0-3.43-1.54-3.43-3.43s1.54-3.43 3.43-3.43S19 3.39 19 5.28s-1.54 3.43-3.43 3.43m0-4.57a1.14 1.14 0 1 0-.001 2.279 1.14 1.14 0 0 0 .001-2.279"
      }), /*#__PURE__*/_jsx("path", {
        d: "M15.57 13.29c-.63 0-1.14-.51-1.14-1.14V7.58a1.14 1.14 0 1 1 2.28 0v4.57c0 .63-.51 1.14-1.14 1.14M19 24.71h-6.86a1.14 1.14 0 1 1 0-2.28H19a1.14 1.14 0 1 1 0 2.28"
      })]
    })
  }));
};